
import React from 'react'
import withFormState from 'src/components/aciacehighway/hocs/withFormState';
import { CreateSKUMgmt } from '../component/sku-mgmt-form';
import { ScopedCssBaseline } from '@mui/material';

function AddPage({ history }) {
  return (<ScopedCssBaseline>
    <CreateSKUMgmt history={history} />
  </ScopedCssBaseline>);
}

export default withFormState(AddPage)
